// @flow
import SubsidyInfo from './SubsidyInfo';

export default SubsidyInfo;
